import React, {Component} from 'react';
import {CardTitle, OutlineButton, P2} from "../Kit/Kit";
import styled from 'styled-components';
import Link from 'gatsby-link';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding: 50px 20px 32px ;
  background: #fff;
  align-items: center;
  justify-content: center;
  
  .content {
    margin: 16px 0;
  }
  
  @media(min-width: 768px) {
    justify-items: left;
    align-items: left;
  
    h1, p {
      text-align: left;
    }
    
    padding: 30px 32px;
  }
  
  @media(min-width: 992px){
    padding: 60px 60px 50px;
    
    .content {
      margin: 32px 0;
    }
  }
  
  a {
        text-decoration: none;
        color: #004a87;
        width: 100%;
        max-width: 120px;
        height: 30px;
          
       @media(min-width: 768px){
         max-width: 190px;
         height: 48px;
      }
  }
  
  p{
    margin: 10px 0;
    
    @media(min-width: 768px){
        margin: 16px 0;
    }
  }
`;

class CardButton extends Component {
    render() {
        const {title, subtitle, buttonText, className, link, header} = this.props;
        return (
          <Container className={className}>
              <CardTitle>{header}</CardTitle>
              <P2
                dangerouslySetInnerHTML={{__html: subtitle}}
              />
              {link ?
                <Link to={link} title={title}> <OutlineButton>{buttonText}</OutlineButton></Link> :
                <OutlineButton>{buttonText}</OutlineButton>
              }
          </Container>
        );
    }
};

export default CardButton;



// WEBPACK FOOTER //
// ./src/components/Home/CardButton.js